import { Signal } from '@angular/core';
import { ProductListItem } from '../../../../../models/product-list/productListItem';
import { TunnelCartLine } from '../models/tunnel-cart-line';

/**
 * Contrat d'accès à la liste d'achat d'un configurateur, et jeton d'injection des composants
 * partagés de l'étape. Chaque configurateur en fournit son implémentation :
 * `providers: [{ provide: TunnelCartService, useExisting: MonCartService }]`.
 */
export abstract class TunnelCartService {
  /** Lignes de la liste d'achat. */
  abstract readonly lines: Signal<TunnelCartLine[]>;

  /** Montant total avant remise. */
  abstract readonly total: Signal<number>;

  /** Montant total après remise ; égal au total lorsqu'aucune remise ne s'applique. */
  abstract readonly totalWithDiscount: Signal<number>;

  /** Indique que la liste n'est plus modifiable. */
  abstract readonly isLocked: Signal<boolean>;

  /** Quantité retenue pour le produit désigné, nulle s'il ne figure pas dans la liste. */
  abstract quantityOf(ean: string): number;

  /** Applique la quantité demandée sur une ligne ; une quantité nulle la retire de la liste. */
  abstract setQuantity(ean: string, quantity: number): void;

  /** Ajoute un produit du catalogue à la liste, ou incrémente sa quantité s'il y figure déjà. */
  abstract addProduct(product: ProductListItem, quantity?: number): void;
}
